// Shown when a route requires a role the current (effective) user lacks. gw
// also enforces this server-side; this is the friendly client-side gate.
export default function AccessDenied({ title = 'Restricted', children }) {
  return (
    <div className="page">
      <div className="access-denied">
        <div className="lock">🔒</div>
        <h2>{title}</h2>
        <p>{children}</p>
      </div>
    </div>
  );
}
